import React from 'react'
import "./products.css"
import Product from './Product/Product'

function Products({products,titleText, innerpage} : any) {
  return (
    <div className='hd-container'>
      {!innerpage && <div className="sec-heading">{titleText}</div>}
      <div className="hd-products">
        {products?.data?.map((item: any) => (
          <Product key={item.id} id={item.id} data={item.attributes}/>
        ))}
      </div>
    </div>
  )
}

export default Products
